import { useContext } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import CustomTabs from '../../../components/common/CustomTabs'
import Title from '../../../components/common/title'
import useSelectedItemSideBar from '../../../hooks/useSelectedItemSideBar'
import MyCertificates from './components/myCertificates'
import NextFormations from './components/nextFormations'
import CustomButton from '../../../components/common/buttons/customButton'
import { ActiveRegionContext } from '../../../context/activeRegionContext'
import LiveHelpIcon from '../../../icons/liveHelpIcon'
import { useMediaQuery } from '@mui/material'

const FormationEnterprise = () => {
  useSelectedItemSideBar('formations.formation-enterprise')
  const { activeRegion } = useContext(ActiveRegionContext)
  const isMobile = useMediaQuery('(max-width:800px)')
  const isSmallMobile = useMediaQuery('(max-width:480px)')
  return (
    <Box sx={{ 
      height: '100%',
      }}>
      <Title>formations Entreprise</Title>
      <Box sx={{ 
      flex: 1,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      paddingBottom: isSmallMobile ? '20px' : isMobile ? '30px' : '40px',
      }}>
        <CustomTabs
          styleTabs={{ mb: isSmallMobile ? '24px' : isMobile ? '32px' : '48px' }}
          list={[
            {
              label: 'PROCHAINES FORMATIONS',
              element: <NextFormations />,
              width: isMobile ? 'auto' : '290px',
            },
            {
              label: 'ATTESTATIONS',
              element: <MyCertificates />,
              width: isMobile ? 'auto' : '219px',
            },
          ]}
        />
                <Box
            sx={{
              border: '1px solid #444D4E',
              p: isSmallMobile ? '20px' : isMobile ? '24px' : '40px',
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              mt: isSmallMobile ? '24px' : isMobile ? '32px' : '51px',
              gap: isMobile ? 2 : 0,
            }}
          >
            <LiveHelpIcon />
                <Box
                  sx={{
                    ml: isMobile ? 0 : '5%',
                    mr: isMobile ? 0 : '8%',
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: isSmallMobile ? '16px' : '24px',
                    mt: isMobile ? 2 : 0,
                  }}
                >
                    <Typography 
                      variant={isSmallMobile ? 'h4' : 'h3'} 
                      textTransform='uppercase'
                      sx={{
                        fontSize: isSmallMobile ? '1.1rem' : isMobile ? '1.3rem' : undefined,
                      }}
                    >
                      BESOIN D'AIDE ?
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: isSmallMobile ? '0.875rem' : isMobile ? '0.95rem' : undefined,
                        lineHeight: 1.6,
                      }}
                    >
                      Contacter nos experts pour adhérer aux services sur demande et pour toutes questions
                      concernants nos services.
                    </Typography>
                </Box>
                <CustomButton
                  variant='principal'
                  href={`${process.env.REACT_APP_JOIN_US}?regionid=${activeRegion}`}
                  sx={{
                    py: isSmallMobile ? '8px' : '11px',
                    px: isSmallMobile ? '20px' : '30px',
                    fontSize: isSmallMobile ? '13px' : '15px',
                    width: isMobile ? '100%' : 'auto',
                    mt: isMobile ? 1 : 0,
                  }}
                >
                  NOUS JOINDRE
                </CustomButton>
          </Box>
      </Box>
    </Box>
  )
}

export default FormationEnterprise
